import ScheduleViewSlots from "./Slots";

import PropTypes from 'prop-types';

import { ReactComponent as ArrowIcon } from 'icons/components/arrow.svg';
import { ReactComponent as EditIcon } from 'icons/buttons/edit.svg';
//import { ReactComponent as TrashIcon } from 'icons/components/trash.svg';

import './index.less';
import './visitsMap.less';
import './themes/default.less';

const intPxMap = {
    5: 120,
    10: 120,
    15: 120,
    30: 120,
    60: 84,
    120: 48,
};

export default class ScheduleViewMainView extends ScheduleViewSlots {
    static propTypes = {
        info: PropTypes.object,
        timeLabel: PropTypes.string,
        getDoctorById: PropTypes.func,
    };

    static defaultProps = {
        info: {},
        timeLabel: "",
        getDoctorById: null,
    };

    constructor(props) {
        super(props);

        this.currentList = 0;
    }

    componentDidMount() {
        this._helper.disconnect(this.windowResize);
        this.windowResize = this._helper.on(window, "resize", this.clearListProp.bind(this));

        this.onRendered();
    }

    componentWillUnmount() {
        this._helper.disconnect(this.windowResize);
    }

    componentDidUpdate() {
        this.onRendered();
    }

    onRendered() {
        const lCount = this.headerItemsNode?.querySelectorAll(".item").length || 0;
        if (lCount)
            this.slideItems(lCount, 0);
    }

    clearListProp() {
        this.setList(0);
    }

    getPercentFromTimes(date, date2) {
        const m = (date.getHours() * 60) + date.getMinutes();
        const m2 = (date2.getHours() * 60) + date2.getMinutes();
        const res = (m2 - m) / this.timeMins;

        return res;
    }

    slideItems(count, flag) {
        const { buferOpened } = this.props.info;
        const { w } = this._helper.dom.coords(document.body);
        const isMiddleScreen = w < 1440;
        const isSmallScreen = w < 1280;
        let listed = this.currentList;

        listed = parseInt(listed) || 0;
        listed += flag;

        let onePage = 4;
        if (isSmallScreen && buferOpened)
            onePage = 1;
        else if (isSmallScreen && !buferOpened)
            onePage = 2;
        else if ((!isMiddleScreen && buferOpened) || (isMiddleScreen && !buferOpened))
            onePage = 3;
        else if (isMiddleScreen && buferOpened)
            onePage = 2;

        if (flag < 0 && listed < 0)
            listed = 0;
        else if (count >= onePage && listed + onePage > count)
            listed = count - onePage;

        this.setList(listed);
    }

    setList(list) {
        this.currentList = list;
        this._helper.dom.styleProp(this.domNode, "list", list);
    }

    insertArrow(count, isLeft = true) {
        const cl = isLeft ? "left rotate180" : "right";

        return (
            <div
                className={"arrow pos abs hand flex centerAll " + cl}
                onClick={this.slideItems.bind(this, count - 1, isLeft ? - 1 : 1)}
            >
                <ArrowIcon />
            </div>
        );
    }

    getIntervalsLines(minutes, startDate, end) {
        const { dateMode, date } = this.props.info;
        const intervals = [];
        const lines = [];

        if (dateMode === "day") {
            const start = new Date(startDate);

            while (start.getTime() <= end.getTime()) {
                const time = this._helper.date.toStr(start, "HH:mm");

                intervals.push((
                    <div key={time} className="interval">
                        <div className="label text p1">{time}</div>
                    </div>
                ));

                lines.push((
                    <div key={time} className="line"></div>
                ));

                start.setMinutes(start.getMinutes() + minutes);
            }
        } else if (dateMode === "week") {
            let { startOfWeek, endOfWeek } = this._helper.date.getWeek(date);

            while (startOfWeek <= endOfWeek) {
                const day = this._helper.date.toStr(startOfWeek, "dd");
                const dt = this._helper.date.toStr(startOfWeek, "DD.MM");

                intervals.push((
                    <div key={dt} className="interval">
                        <div className="label flex col start">
                            <span className="dayTime text p1">{this._helper.string.capitalize(day)}</span>
                            <span className="dateTime text p2">{dt}</span>
                        </div>
                    </div>
                ));

                lines.push((
                    <div key={dt} className="line"></div>
                ));

                startOfWeek.setDate(startOfWeek.getDate() + 1);
            }

            intervals.push((
                <div key={36565} className="interval">
                </div>
            ));
        }

        return { intervals, lines };
    }

    getDataForCabinet(date, bt, et, info) {
        const beginDate = this._helper.date.setTime(date, bt);
        const endDate = this._helper.date.setTime(date, et);

        let data = null;
        info.forEach(it => {
            const bd = this._helper.date.toStr(beginDate);
            const ed = this._helper.date.toStr(endDate);
            const equealDates = this._helper.date.intervalsOverlap(bd, ed, it.beginDate, it.endDate);
            if (equealDates) {
                if (!data)
                    data = [it];
                else
                    data.push(it);
            }
        });

        return data;
    }

    setShiftForCabinet(title, domainId, cabinetId, date) {
        const { shifts, schedules, isEdit } = this.props.info;
        const sh = [];

        shifts[this._helper.date.getNumberDayOfWeek(date)].forEach(shift => {
            const { start, end, id: shiftItemId } = shift;

            const originalBeginTime = `2024-01-04T${start}.000+00:00`;
            const originalEndTime = `2024-01-04T${end}.000+00:00`;
            const startDate = this._helper.date.getTimeToday(originalBeginTime);
            const endDate = this._helper.date.getTimeToday(originalEndTime);
            const from = this.getPercentFromTimes(this._helper.date.getTimeToday("2024-01-04T08:00:00.000+00:00"), startDate);
            const size = this.getPercentFromTimes(startDate, endDate);

            const item = { title, from, size, start, end, date, shiftItemId, cabinetId, domainId, isEdit };
            if (schedules[cabinetId]) {
                item.data = this.getDataForCabinet(date, start, end, schedules[cabinetId]);
            }


            sh.push(item);
        });

        return sh;
    }

    setShiftForCabinetWeek(title, domainId, cabinetId, date) {
        const { schedules, isEdit, dateMode } = this.props.info;

        const sh = [];
        let from = 0;
        const { startOfWeek } = this._helper.date.getWeek(date);

        [0, 1, 2, 3, 4, 5, 6].forEach(numDay => {
            const size = 0.95;
            const row = { title, from, size, date: this._helper.date.addDays(startOfWeek, numDay), cabinetId, domainId, isEdit, dateMode };

            if (schedules[cabinetId]) {
                schedules[cabinetId].forEach(sch => {
                    const numberDayOfWeek = this._helper.date.getNumberDayOfWeek(new Date(sch.beginDate));
                    if (numberDayOfWeek === numDay) {
                        if (!row.data)
                            row.data = [sch];
                        else
                            row.data.push(sch);
                    }
                });
            }

            sh.push(row);
            from += 1;
        });

        return sh;
    }

    async deleteCabinet(id) {
        this._helper.showLoading();
        await this._request.cabinets.delete(id);
        this._helper.hideLoading();
        this.props.refreshVisits();
    }

    deleteCabinetConfirm(id) {
        this._helper.confirm(
            { title: "schedule.deleteCabinet", message: this.tr("schedule.confirmDeleteCabinet") },
            this.deleteCabinet.bind(this, id)
        );
    }

    renderHeader(labels) {
        const { dateMode, isEditCabinet, domainId } = this.props.info;

        const count = labels.length;

        return (
            <div className="header flex">
                {dateMode !== "month" && <div className="times"></div>}
                <div className="items pos rel flex1 flex" ref={el => this.headerItemsNode = el}>
                    {labels.map(({ title, cabinetId }, i) => {
                        return (
                            <div key={i} className="item flex1 text p1 flex centerAll gap8">
                                <div>{title}</div>
                                {isEditCabinet &&
                                    <div className="editicon hand"
                                        onClick={this._helper.openDialog.bind(this, "cabinet", { create: false, name: title, id: cabinetId, domainId }, this.props.refreshVisits.bind(this))}>
                                        <EditIcon />
                                    </div>}
                            </div>
                        );
                    })}
                    {this.insertArrow(count)}
                    {this.insertArrow(count, false)}
                </div>
            </div>
        );
    }

    render() {
        const { info } = this.props;
        const { dateMode, activeCabinets, selectedCabinets, buferOpened, currentTime, editDoctorsMode, canceledMode, date, shifts } = info;

        if (shifts[0].length < 1)
            return false;

        if (!activeCabinets)
            return null;

        const booferCl = buferOpened ? " booferActive" : "";
        const canceledCl = canceledMode ? "isCanceled" : "";

        this.isFullDay = currentTime === 120;
        this.intPx = intPxMap[currentTime];

        this.timeMins = this.isFullDay ? 60 : currentTime;

        let labels = [];
        const slotsOnDay = [];
        this.doctorsNodes = {};

        if (dateMode === "day") {
            activeCabinets.filter(it => selectedCabinets.includes(it.id)).forEach(cab => {
                const { title, domainId, id: cabinetId } = cab;
                labels.push({ title, cabinetId });
                slotsOnDay.push([...this.setShiftForCabinet(title, domainId, cabinetId, date)]);
            });

        } else if (dateMode === "week") {
            this.intPx += 66;
            activeCabinets.filter(it => selectedCabinets.includes(it.id)).forEach(cab => {
                const { title, domainId, id: cabinetId } = cab;
                labels.push({ title, cabinetId });
                slotsOnDay.push([...this.setShiftForCabinetWeek(title, domainId, cabinetId, date)]);
            });
        }

        const startDef = this._helper.date.addDays(null, 10);
        let start = this._helper.date.create(startDef);

        const endDef = this._helper.date.addDays(null, -10);
        let end = this._helper.date.create(endDef);

        this.currentDoctorVisits = {};
        this.visitsNodes = {};
        this.doctorsNodes = {};

        start = this._helper.date.getTimeToday((editDoctorsMode || startDef.getTime() === start.getTime()) ? this._config.workDayStart : start);
        end = this._helper.date.getTimeToday((editDoctorsMode || endDef.getTime() === end.getTime()) ? this._config.workDayEnd : end);

        this.startTime = start;
        this.endTime = end;

        const { intervals } = this.getIntervalsLines(this.timeMins, start, end, dateMode);

        slotsOnDay.sort((a, b) => b.some(it => it.data) - a.some(it => it.data));
        labels = slotsOnDay.map(it => { const { title, cabinetId } = it[0]; return { title, cabinetId }; });
        this.slotsOnDay = slotsOnDay;

        return (
            <div
                ref={el => this.domNode = el}
                className={"scheduleView flex1 scrolling" + booferCl}
                style={{ "--list": 0 }}
            >
                <div className="pos rel flex col minH100">
                    {this.renderHeader(labels)}
                    <div className={`container flex1 flex hidden m${currentTime} ${canceledCl}`} style={{ "--intPx": this.intPx + "px" }}>
                        {dateMode !== "month" && <div className="times">
                            {intervals}
                        </div>}
                        <div className="itemsCont pos rel flex1 flex">
                            <div ref={el => this.timeLinePointer = el} className="timeLine pos abs" style={{ "--from": -1 }}>
                                <div ref={el => this.timeLinePointerLabel = el} className="label pos abs text p1 rad8"></div>
                            </div>
                            <div className="items flex1 flex hidden" ref={el => this.itemsNode = el}>
                                {labels.map((_, i) => {
                                    return (
                                        <div key={i} className="item pos rel flex1 text p1">
                                            {slotsOnDay[i] && slotsOnDay[i].map((it, ind) => {
                                                return this.insertSlot(it, ind);
                                            })}
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
